import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';
import Button from '@mlb/react-patterns/components/Button/button.tsx';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';

const ToggleButton = styled(Button)`
    &&& {
        position: absolute;
        top: 0;
        right: 0;
        height: 25px;
        padding-right: 6px;
        padding-left: 6px;
        background-color: ${COLORS.mlbGrey6};
        color: ${COLORS.mlbWhite};
        border-radius: 50%;
        font-family: ${FONTS.primaryFont};
        ${mainCq.md`
            display: none;
        `}
    }
`;

export default ToggleButton;
